"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _icon_wrapper = _interopRequireDefault(require("./icon_wrapper"));
var _templateObject;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
var Wrapper = _styled["default"].div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  border-radius: 50%;\n  display: inline-block;\n  overflow: hidden;\n  width: ", ";\n  height: ", ";\n"])), function (props) {
  return props.width;
}, function (props) {
  return props.width;
});
var FlagEnIcon = /*#__PURE__*/function (_React$Component) {
  function FlagEnIcon() {
    _classCallCheck(this, FlagEnIcon);
    return _callSuper(this, FlagEnIcon, arguments);
  }
  _inherits(FlagEnIcon, _React$Component);
  return _createClass(FlagEnIcon, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react["default"].createElement(Wrapper, {
        width: this.props.width
      }, /*#__PURE__*/_react["default"].createElement("svg", {
        viewBox: "0 0 80 80",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg"
      }, /*#__PURE__*/_react["default"].createElement("g", {
        id: "Page-1",
        stroke: "none",
        fill: "none"
      }, /*#__PURE__*/_react["default"].createElement("g", {
        id: "brit_icon"
      }, /*#__PURE__*/_react["default"].createElement("g", {
        id: "Shape"
      }, /*#__PURE__*/_react["default"].createElement("polygon", {
        id: "Path",
        fill: "#09438D",
        points: "0.28 8.58758621 0.28 30.3434483 22.6141667 30.3434483"
      }), /*#__PURE__*/_react["default"].createElement("polygon", {
        id: "Path",
        fill: "#E7394E",
        points: "25.8358333 30.3434483 30.4075 30.3434483 0.28 0.885517241 0.28 5.5062069"
      }), /*#__PURE__*/_react["default"].createElement("polygon", {
        id: "Path",
        fill: "#09438D",
        points: "9.08583333 0.885517241 34.5958333 26.8731034 34.5958333 0.885517241"
      })), /*#__PURE__*/_react["default"].createElement("polygon", {
        id: "Shape",
        fill: "#09438D",
        points: "79.73 70.9682759 79.73 49.4027586 57.6266667 49.4027586"
      }), /*#__PURE__*/_react["default"].createElement("polygon", {
        id: "Shape",
        fill: "#E7394E",
        points: "54.4058333 49.4027586 49.8333333 49.4027586 79.73 78.7158621 79.73 74.0496552"
      }), /*#__PURE__*/_react["default"].createElement("polygon", {
        id: "Shape",
        fill: "#09438D",
        points: "71.15 79.0537931 45.64 53.0675862 45.64 79.0537931"
      }), /*#__PURE__*/_react["default"].createElement("polygon", {
        id: "Shape",
        fill: "#09438D",
        points: "79.73 8.78344828 79.73 30.3434483 57.6266667 30.3172414"
      }), /*#__PURE__*/_react["default"].createElement("polygon", {
        id: "Shape",
        fill: "#E7394E",
        points: "45.6458333 30.3434483 50.8341667 30.3434483 79.73 0.885517241 74.4816667 0.885517241"
      }), /*#__PURE__*/_react["default"].createElement("polygon", {
        id: "Shape",
        fill: "#09438D",
        points: "70.9316667 0.885517241 45.6458333 26.68 45.6458333 0.885517241"
      }), /*#__PURE__*/_react["default"].createElement("polygon", {
        id: "Shape",
        fill: "#09438D",
        points: "0.281666667 71.1531034 0.281666667 49.3972414 22.6158333 49.3972414"
      }), /*#__PURE__*/_react["default"].createElement("polygon", {
        id: "Shape",
        fill: "#E7394E",
        points: "34.5841667 49.3931034 29.3975 49.3931034 0.265 79.0758621 5.5175 79.0758621"
      }), /*#__PURE__*/_react["default"].createElement("polygon", {
        id: "Shape",
        fill: "#09438D",
        points: "9.07583333 79.0441379 34.5841667 53.0565517 34.5841667 79.0441379"
      }), /*#__PURE__*/_react["default"].createElement("rect", {
        id: "Rectangle",
        fill: "#FFFFFF",
        x: "30",
        y: "1",
        width: "20",
        height: "78"
      }), /*#__PURE__*/_react["default"].createElement("rect", {
        id: "Rectangle-path",
        fill: "#E7394E",
        x: "33.4425",
        y: "0.885517241",
        width: "13",
        height: "78.1696552"
      }), /*#__PURE__*/_react["default"].createElement("rect", {
        id: "Rectangle-path",
        fill: "#E7394E",
        x: "0.28",
        y: "33.7131034",
        width: "79.4558333",
        height: "12.582069"
      })))));
    }
  }]);
}(_react["default"].Component);
FlagEnIcon.defaultProps = {
  width: '20px'
};
var _default = exports["default"] = (0, _icon_wrapper["default"])(FlagEnIcon);